import { Modal } from "react-bootstrap";

const CustomModal = ({ isOpen, title, handleClose, children }) => {
    return (
        <Modal
            show={isOpen}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <button onClick={handleClose} type="button" className="btn btn-label-secondary btn-icon common_hover">
                    <i className="fa fa-times"></i>
                </button>
            </Modal.Header>
            <hr style={{ 'margin': '0px' }} />
            <Modal.Body style={{ textAlign: "center" }}>{children}</Modal.Body>
        </Modal>
    );
};

export default CustomModal;